import { useState, useEffect } from 'react'
import STATIC_REGIONS from '../../data/regions'
import api from '../../utils/api'
import ar from '../../locales/ar.json'

export default function RegionSelect({ regionValue, neighborhoodValue, onRegionChange, onNeighborhoodChange, errors }) {
  const [regions, setRegions]               = useState(STATIC_REGIONS)
  const [neighborhoods, setNeighborhoods]   = useState([])
  const [subAreas, setSubAreas]             = useState([])

  // Try to load from backend (admin-managed), fallback to static
  useEffect(() => {
    api.get('regions').then((r) => {
      if (r.data?.length) setRegions(r.data)
    }).catch(() => {})
  }, [])

  useEffect(() => {
    if (!regionValue) { setNeighborhoods([]); setSubAreas([]); return }
    const region = regions.find((r) => r.name === regionValue || r.id === regionValue)
    setNeighborhoods(region?.neighborhoods || [])
    setSubAreas([])
    if (!region?.neighborhoods?.find((n) => n.name === neighborhoodValue)) {
      onNeighborhoodChange('')
    }
  }, [regionValue, regions])

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      {/* Region */}
      <div>
        <label htmlFor="region" className="label-base">
          {ar.step6.region}
          <span className="text-red-500 mr-1">*</span>
        </label>
        <select
          id="region"
          value={regionValue || ''}
          onChange={(e) => onRegionChange(e.target.value)}
          className="input-base"
          aria-required="true"
          aria-describedby={errors?.region ? 'region-error' : undefined}
        >
          <option value="">{ar.app.selectRegion}</option>
          {regions.map((r) => (
            <option key={r.id || r.name} value={r.name}>{r.name}</option>
          ))}
        </select>
        {errors?.region && (
          <p id="region-error" className="mt-1 text-xs text-red-600" role="alert">
            {errors.region}
          </p>
        )}
      </div>

      {/* Neighborhood */}
      <div>
        <label htmlFor="neighborhood" className="label-base">
          {ar.step6.neighborhood}
          <span className="text-red-500 mr-1">*</span>
        </label>
        <select
          id="neighborhood"
          value={neighborhoodValue || ''}
          onChange={(e) => onNeighborhoodChange(e.target.value)}
          disabled={!neighborhoods.length}
          className="input-base"
          aria-required="true"
          aria-describedby={errors?.neighborhood ? 'neighborhood-error' : undefined}
        >
          <option value="">{ar.app.selectNeighborhood}</option>
          {neighborhoods.map((n) => (
            <option key={n.id || n.name} value={n.name}>{n.name}</option>
          ))}
        </select>
        {errors?.neighborhood && (
          <p id="neighborhood-error" className="mt-1 text-xs text-red-600" role="alert">
            {errors.neighborhood}
          </p>
        )}
      </div>
    </div>
  )
}
